import axios from "axios";
import { forceFileDownload } from "../../../common/utils";

export async function getProductsPendingShipping({ startDate, endDate }) {
  let queryStr = "";
  if (startDate) {
    queryStr = `?startDate=${startDate}&endDate=${endDate}`;
  }
  try {
    const res = await axios.get(`order-admin/productsPendingShippingDetails${queryStr}`);
    return res.data;
  } catch (error) {
    console.log(JSON.stringify(error));
  }
}

export async function saveShipping(data) {
  try {
    const response = await axios.post(`shipping`, data);
    return response.data;
  } catch (error) {
    console.log(JSON.stringify(error));
  }
}

export async function rejectProducts(data) {
  try {
    const response = await axios.patch(`order-admin/rejectItems/?rejectionStage=SHIPPED_PENDING`, data);
    return response.data;
  } catch (error) {
    console.log(JSON.stringify(error));
    throw error;
  }
}

export async function downloadSupplierOrderRequestExcel(ids, showCost, action) {
  const body = {
    ids,
    showCost,
    action,
  };
  try {
    const response = await axios.post(`excel-generation/GenerateSupplierWiseOrderRequest`, body, { responseType: "arraybuffer" });
    forceFileDownload(response, "Supplier Wise Branch Orders");
  } catch (error) {
    console.log(JSON.stringify(error));
  }
}
